import TopSection from "../../LT/TopSection";

const ForecastCollabDPS = () => {
    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "DPS Forecast" },
                ]}
                tabTitle="DPS Forecast"
            />
        </div>
    )
}

export default ForecastCollabDPS;